import { useMutation } from '@tanstack/react-query';
import impactMeterService from 'v2/services/impactMeter';

type CreateImpactCertificateInput = {
  userId: number;
  name: string;
};

export function useImpactCertificate() {
  return useMutation({
    mutationFn: ({ userId, name }: CreateImpactCertificateInput) => {
      return impactMeterService.createCertificate(userId, name);
    }
  });
}
